var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionnaireSurvey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 682.66669 682.66669",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h90v-452h-360V0h90",
    style: {
      stroke: "#000",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    fill: "none",
    stroke: "#000",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    transform: "translate(285 467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 16.569-13.431 30-30 30-16.569 0-30-13.431-30-30h-60v-60H60V0Z",
    style: {
      stroke: "#000",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    fill: "none",
    stroke: "#000",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    transform: "translate(225 467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h90",
    style: {
      stroke: "#000",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    fill: "none",
    stroke: "#000",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    transform: "translate(180 107)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h150",
    style: {
      stroke: "#000",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    fill: "none",
    stroke: "#000",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    transform: "translate(180 317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h150",
    style: {
      stroke: "#000",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    fill: "none",
    stroke: "#000",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    transform: "translate(180 167)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h90",
    style: {
      stroke: "#000",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    fill: "none",
    stroke: "#000",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    transform: "translate(180 257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 30-30 60 60",
    style: {
      stroke: "#000",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    fill: "none",
    stroke: "#000",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    transform: "translate(60 317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 60-60",
    style: {
      stroke: "#000",
      strokeWidth: 30,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    fill: "none",
    stroke: "#000",
    strokeWidth: 30,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    transform: "translate(75 167)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-60-60",
    style: {
      stroke: "#000",
      strokeWidth: 30,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    fill: "none",
    stroke: "#000",
    strokeWidth: 30,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    transform: "translate(135 167)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-270l-30-60-30 60V0Z",
    style: {
      stroke: "#000",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    fill: "none",
    stroke: "#000",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    transform: "translate(497 377)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60",
    style: {
      stroke: "#000",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    fill: "none",
    stroke: "#000",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    transform: "translate(437 137)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60",
    style: {
      stroke: "#000",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    fill: "none",
    stroke: "#000",
    strokeWidth: 30,
    strokeMiterlimit: 10,
    "data-original": "#000000",
    transform: "translate(437 317)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaireSurvey);
export default __webpack_public_path__ + "static/media/questionnaire-survey.5cdba99c40e1e0898c29caa43ee8632f.svg";
export { ForwardRef as ReactComponent };